var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointsButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 4,
    viewBox: "0 0 17 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2C4.5 3.10457 3.60457 4 2.5 4C1.39543 4 0.5 3.10457 0.5 2C0.5 0.895431 1.39543 0 2.5 0C3.60457 0 4.5 0.895431 4.5 2Z",
    fill: "#BDC5DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C10.5 3.10457 9.60457 4 8.5 4C7.39543 4 6.5 3.10457 6.5 2C6.5 0.895431 7.39543 0 8.5 0C9.60457 0 10.5 0.895431 10.5 2Z",
    fill: "#BDC5DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4C15.6046 4 16.5 3.10457 16.5 2C16.5 0.895431 15.6046 0 14.5 0C13.3954 0 12.5 0.895431 12.5 2C12.5 3.10457 13.3954 4 14.5 4Z",
    fill: "#BDC5DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsButton);
export default __webpack_public_path__ + "static/media/points-button.fe8d890ab654620098faf0a8979bb69d.svg";
export { ForwardRef as ReactComponent };